const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const SettingsButton = require("./SettingsButton");
const _ = require("lodash");

const styles = require("./styles/SettingsButtonContainer.css");

module.exports = createReactClass({
	displayName: "settingsButtonContainer",

	propTypes: {
		className: PT.string,
		settingsField: PT.string.isRequired,
		buttonValues: PT.array.isRequired,
		buttonDrawFunctions: PT.array.isRequired,
		onButtonClick: PT.func,
		currentValue: PT.any,
	},

	// Find the index of the button with a value equal to currentValue.
	// Returns null if it can't be found.
	getSelectedIndex: function() {
		const currentValue = this.props.currentValue;
		let selectedIndex = null;
		if (!_.isUndefined(currentValue)) {
			const valueIndex = _.indexOf(this.props.buttonValues, currentValue);
			selectedIndex = valueIndex === -1 ? null : valueIndex;
		}
		return selectedIndex;
	},

	UNSAFE_componentWillMount: function() {
		this.buttonViews = [];
	},

	onButtonClick: function(i) {
		this.props.onButtonClick &&
			this.props.onButtonClick(this.props.buttonValues[i]);
	},

	render: function() {
		const selectedIndex = this.getSelectedIndex();
		const buttons = this.props.buttonValues.map((v, i) => {
			return (
				<div className={styles.buttonWrapper} key={i}>
					<SettingsButton
						flipWonkiness={i % 2 === 0}
						draw={this.props.buttonDrawFunctions[i]}
						isSelected={i === selectedIndex}
						onClick={() => this.onButtonClick(i)}
					/>
				</div>
			);
		});
		const className = styles.body + " " + (this.props.className || "");
		return <div className={className}>{buttons}</div>;
	},
});
